import { useState, useCallback } from 'react';
import { Appointment } from './types/appointment./ts';
import { appointments as initialAppointments } from '../data/mockData.ts';
//import { toast } from 'sonner';
//import { format } from 'date-fns';
//import { ptBR } from 'date-fns/locale';

export function useAppointments() {
  const [appointments, setAppointments] = useState<Appointment[]>(initialAppointments);

  const moveAppointment = useCallback((appointmentId: string, newDate: Date, newTime?: string) => {
    setAppointments((prev) => {
      return prev.map((apt) => {
        if (apt.id === appointmentId) {
          const updatedDate = new Date(newDate);
          
          let startTime = apt.startTime;
          let endTime = apt.endTime;
          
          if (newTime) {
            startTime = newTime;
            // Calculate end time based on duration
            const [startHour, startMin] = apt.startTime.split(':').map(Number);
            const [endHour, endMin] = apt.endTime.split(':').map(Number);
            const durationMinutes = (endHour * 60 + endMin) - (startHour * 60 + startMin);
            
            const [newHour, newMin] = newTime.split(':').map(Number);
            const newEndMinutes = newHour * 60 + newMin + durationMinutes;
            const newEndHour = Math.floor(newEndMinutes / 60);
            const newEndMin = newEndMinutes % 60;
            endTime = `${newEndHour.toString().padStart(2, '0')}:${newEndMin.toString().padStart(2, '0')}`;
          }

         //toast.success(`Agendamento movido para ${updatedDate}`);
          
          return {
            ...apt,
            date: updatedDate,
            startTime,
            endTime,
          };
        }
        return apt;
      });
    });
  }, []);

  return { appointments, setAppointments, moveAppointment };
}
